export const DEFAULT_UOM = 'EA';
export const ALTERNATE_PART_NUMBER_MAX_LENGTH = 100;
